import PropTypes from 'prop-types';
import { ComponentLoader } from '../../../global/ComponentLoader/ComponentLoader';

const importFunc = () => {
    return import(
        /* webpackChunkName: "PdpSharedDepositModal" */
        './PdpSharedDepositModal'
    ).then(moduleExport => moduleExport.PdpSharedDepositModal);
};

export function PdpSharedDepositModalLoader(props) {
    return <ComponentLoader {...props} load={props.isOpen} importFunc={importFunc} />;
}

PdpSharedDepositModalLoader.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    buyerId: PropTypes.string,
    itemId: PropTypes.string.isRequired,
};
